import React, { FC } from 'react';

import DownArrow from '@material-ui/icons/KeyboardArrowDownRounded';
import UpArrow from '@material-ui/icons/KeyboardArrowUpRounded';
import Line from '@material-ui/icons/RemoveRounded';
import Button from '../../../../components/Button';
import { TOrderType } from './PlayerList';

interface IProps {
  type: any;
  order?: TOrderType;
  sort: (sortBy: string) => (_: any) => void;
  groupEdition?: boolean;
  mobileVersion?: boolean;
}

export const PlayerListTitleRow: FC<IProps> = props => {
  const { type, order, sort, groupEdition, mobileVersion } = props;

  const IconsMap = {
    ascending: DownArrow,
    descending: UpArrow,
    original: Line
  };

  const items = mobileVersion ? mobileRowItems : rowItems;

  return (
    <div className="paper-player black">
      <div className="title-row">
        <div className="player-list-title-button select">SELECT</div>

        {items.map(item => {
          const { label, extraClassName, orderBy } = item;

          const IconComponent = type === orderBy && order ? IconsMap[order] : Line;

          return (
            <Button
              key={`order-icon-button-${item.label}`}
              className={`player-list-title-button override ${extraClassName}`}
              onClick={sort(orderBy)}
            >
              {label}
              <IconComponent classes={{ root: 'player-list-icon override' }} />
            </Button>
          );
        })}

        {!!groupEdition && <div className="player-list-title-button index" />}
      </div>
    </div>
  );
};

const rowItems = [
  { label: 'FIRST', extraClassName: 'firstname', orderBy: 'user.firstName' },
  { label: 'LAST', extraClassName: 'lastname', orderBy: 'user.lastName' },
  { label: 'GHIN', extraClassName: 'ghin', orderBy: 'user.profile.ghinNumber' },
  { label: 'INDEX', extraClassName: 'index', orderBy: 'user.profile.handicapCurrent' }
];

const mobileRowItems = [
  { label: 'FIRST', extraClassName: 'firstname', orderBy: 'user.firstName' },
  { label: 'LAST', extraClassName: 'lastname', orderBy: 'user.lastName' }
];
